import React, { ReactNode, useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';

// Material-ui
import { Grid } from '@material-ui/core';

// Components
import Footer from '@components/UI-KIT/Footer';
import Button from '../Button';

// Icons
import { Delete } from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables';
import './Filters.scss';

export interface FilterProps<FilterType> {
    filters: FilterType;
    setFilters: React.Dispatch<React.SetStateAction<FilterType>>;
    handleFetchData: () => void;
    resetFilters: () => void;
}

interface Props {
    children: ReactNode;
    resetFilters: () => void;
    resetDisabled: boolean;
    handleFetchData: () => void;
}

const Filters: React.FC<Props> = ({
    children,
    resetFilters,
    resetDisabled,
    handleFetchData
}) => {
    const [ fetchActionTrigger, setFetchActionTrigger ] = useState('*');

    useEffect(() => {
        fetchActionTrigger !== '*' && handleFetchData();
    }, [ fetchActionTrigger ]);

    return (
        <Grid>
            {children}
            <Footer>
                <Grid
                    className="ui-Filters-footer-container"
                    container
                    justify="space-between"
                >
                    <Button
                        label="Limpiar filtros"
                        onClick={() => {
                            resetFilters();
                            setTimeout(() => setFetchActionTrigger(uuid()), 100);
                        }}
                        icon={(
                            <Delete
                                color={resetDisabled ? VARIABLES.palette.content_color : VARIABLES.palette.error_color}
                            />
                        )}
                        level={3}
                        errorColor
                        disabled={resetDisabled}
                    />
                    <Button
                        label="Aplicar filtros"
                        onClick={() => handleFetchData()}
                    />
                </Grid>
            </Footer>
        </Grid>
    );
};

export default Filters;